(function Landing($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		Adzuki.onload('WebsitePages/landing', function onload()
		{
			var $modal = $(".modal");

			// Resize additional content iframe height to left section div
			$('.landing-page-additional-content iframe').css('height', $('#description-section-left').height());

			$(window).resize(function manageIframe() {
				$('.landing-page-additional-content iframe').css('height', $('#description-section-left').height());
			});

			$('.offer-details').click(function _showModal(e) {
				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').html($(this).data('modal-body'));
				$modal.find('.modal-title').text($(this).data('modal-title'));
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$("a.vendor-box").on('click', function showInfo(e) {
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html();

				e.preventDefault();
				$modal.addClass('wide');
				$modal.find('.modal-title').text($self.text());
				$modal.find('.modal-body').html(body);
				$('.modal').addClass('wide');
				$modal.modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));
